/* eslint-disable */
import { BlogPage } from '@/components/modules/pages/blog';
import { SCREEN_NAME } from '@/constants/analytics';
import { getHomeDescription, isSistaminuten, trackPage, url } from '@/helpers';
import { trackScreenShown } from '@/hooks/useTrackScreenShown';
import { __ } from '@/locale';
import { Helmet } from 'react-helmet';

const getSEO = () => {
  const title = __('seo.termsGiftcardTitle');
  const description = getHomeDescription();
  const pageUrl = `${url.getBaseUrl()}articles/terms-giftcard-consumer`;
  const imageUrl = url.getBaseImageUrl();
  const isNoIndex = isSistaminuten();

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={pageUrl} />

      <meta property="og:url" content={pageUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      {isNoIndex && <meta name="robots" content="noindex" />}
    </Helmet>
  );
};

const trackPageVisit = () => {
  trackPage();
  trackScreenShown({ screen_name: SCREEN_NAME.TERMS_GIFTCARD_CONSUMER });
};

const TermsGiftcard = () => (
  <BlogPage
    pageId="3724"
    pageTitle={__('termsGiftcardTitle')}
    pageClassName="termsContent"
    seo={getSEO()}
    trackPage={trackPageVisit}
  />
);

export default TermsGiftcard;
